import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { ApiResponse } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class ApprovalWorkflowService {
    constructor(private readonly http: HttpService) {}

    createApprovalWorkflow(payload: any): Observable<ApiResponse<any>> {
        return this.http.post<ApiResponse<any>>('ApprovalSetting/save-approval-setup', payload);
    }

    getApprovalWorkflowById(workflowName: string): Observable<ApiResponse<any>> {
        return this.http.get<ApiResponse<any>>(`ApprovalSetting/get-approval-setup/${workflowName}`);
    }

    updateApprovalWorkflow(payload: any): Observable<ApiResponse<any>> {
        return this.http.put<ApiResponse<any>>('ApprovalSetting/update-approval-setup', payload);
    }
    deleteApprovalWorkflow(id: string): Observable<ApiResponse<any>> {
        return this.http.delete<ApiResponse<any>>(`ApprovalSetting/delete-approval-setup/${id}`);
    }
    getApproversByApprovalType(pageId: string, approvalTypeId: string): Observable<ApiResponse<any>> {
        return this.http.get<ApiResponse<any>>(`approver/get-approvers-by-approvaltype/${pageId}/${approvalTypeId}`);
    }

    /** Count of items pending the current user's approval, across all modules — for the topbar badge. */
    getPendingApprovalCount(): Observable<ApiResponse<number>> {
        return this.http.get<ApiResponse<number>>('MyApprovals/get-pending-count');
    }
}
